import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as querystring from 'querystring';
import * as React from 'react';
import { API, UnsubscribeResponse } from '../api/api';
import { reportError } from '../telemetry';
import { unreachable } from '../utils';
import { InjectAPI } from './app/app';
import { Spinner } from './widgets/spinner';

@inject('api')
@observer
class UnsubscribeInner extends React.Component<InjectAPI> {
  private readonly store: Store;

  constructor(props: InjectAPI) {
    super(props);
    this.store = new Store(props.api);
  }

  public componentWillMount() {
    const query = querystring.parse<UnsubscribeQuery>(location.search.slice(1));
    this.store.unsubscribeUUID(query.booking_uuid).catch(reportError);
  }

  public render() {
    if (this.store.state === State.LOADING)
      return this.renderLoading();
    else if (this.store.state === State.SUCCESS)
      return this.renderSuccess();
    else if (this.store.state === State.ERROR)
      return this.renderError();
    else
      return unreachable(this.store.state);
  }

  private renderLoading() {
    return <Spinner/>;
  }

  private renderSuccess() {
    return (
      <div className="error container">
        <h1>Thank you.</h1>
        <p>
          You have successfully unsubscribed and will no longer receive these types of offers in the future.
        </p>
        <p className="small">
          <a target="_blank" href="https://www.alaskaair.com/">Visit alaskaair.com</a>
        </p>
      </div>
    );
  }

  private renderError() {
    return (
      <div className="error container">
        <h1>We're sorry.</h1>
        <p>
          There was an issue processing your request.
        </p>
        <p className="small">
          <a target="_blank" href="https://www.alaskaair.com/">Visit alaskaair.com</a>
        </p>
      </div>
    );
  }
}

export const Unsubscribe = UnsubscribeInner as React.ComponentClass;

interface UnsubscribeQuery {
  readonly booking_uuid: string;
}

const enum State {
  LOADING, ERROR, SUCCESS,
}

class Store {
  @observable public state = State.LOADING;  // tslint:disable-line:readonly-keyword

  constructor(private readonly api: API) { }

  @action
  public async unsubscribeUUID(uuid: string) {
    this.state = State.LOADING;

    try {
      this.handleUnsubscribeResponse(await this.api.unsubscribe(uuid));
    } catch (e) {
      reportError(e);
      this.handleUnsubscribeResponse({ tag: 'unexpected-error' });
    }
  }

  @action
  private handleUnsubscribeResponse(result: UnsubscribeResponse) {
    this.state = result.tag === 'ok' ? State.SUCCESS : State.ERROR;
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/unsubscribe.tsx